<script setup lang="ts">
import type { NovaCalendarWeekDaysProps } from './NovaCalendarWeekDays.types'

defineProps<NovaCalendarWeekDaysProps>()
</script>

<template>
  <div :class="['calendar-week-days grid-wrapper grid-7 gap-16']">
    <div v-for="(weekday, index) in weekdays" :key="index" class="weekday-item">
      <span class="weekday">{{ weekday }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.calendar-week-days {
  flex-shrink: 0;
  position: relative;
  width: 100%;
  padding-bottom: 12px;

  @include mobile {
    grid-gap: 2px;
    padding: 0 8px 8px;
  }

  &:after {
    position: absolute;
    left: 50%;
    bottom: 0;
    display: block;
    content: '';
    height: 1.69px;
    width: calc(100% - 12px * 2);
    background-color: #e1e4e7;
    transform: translateX(-50%);
  }

  .weekday-item {
    display: flex;
    align-items: center;
    justify-content: center;

    > .weekday {
      font-size: 18px;
      font-weight: 500;
      color: hex-to-rgba(#34485e, 0.5361);

      @include mobile {
        font-size: 17.22px;
      }
    }
  }
}
</style>
